module.exports = __webpack_public_path__ + "img/82.f913da18.jpg";